import { RogueCaseMeeting } from '../models';
import { SCondition, RequestQueryBuilder } from '@nestjsx/crud-request';
import { RogueTrackerActions } from '../models';
import { RogueRecommendationTypes } from '../models';
import { RogueTeam } from '../models';
import { RogueCaseUpdates } from '../models';
import { map } from 'rxjs/operators';
import { ManyResponse } from '../../../responses';
import { RogueCase } from '../models';
import { Injectable } from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Burly} from 'kb-burly';
import {Cacheable} from 'ts-cacheable';
import {RogueCaseActionLog} from '../models/rogue-cases/rogue-case-action-log.model';

@Injectable({
  providedIn: 'root'
})
export class TorchCaseManagementService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  @Cacheable()
  public getCaseCount(filter?: string | string[]): Observable<number> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/case-mgmt')
    .addSegment('/count');

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}&filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<number>(finalURL);
  }

  getCasesByCPN(companyPartNumber: string, excludeId?: number) {
    let endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .get;

    const filter1 = 'cpn||$eq||"' + companyPartNumber + '"';

    endpoint = `${endpoint}?filter=${encodeURIComponent(filter1)}`;

    if (!!excludeId) {
      const filter2 = 'id||$ne||' + excludeId;
      endpoint = `${endpoint}&filter=${encodeURIComponent(filter2)}`;
    }

    return this.httpClient.get<ManyResponse<RogueCase>>(endpoint);
  }

  getCasesByCPNAndMSN(companyPartNumber: string, manufacturersSerialNumber: string, excludeId?: number) {
    let endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      // .addQuery('filter', 'cpn||$eq||' + companyPartNumber)
      // .addQuery('filter', 'msn||$eq||"' + manufacturersSerialNumber + '"')
      .get;

    const filter1 = 'cpn||$eq||"' + companyPartNumber + '"';
    const filter2 = 'msn||$eq||"' + manufacturersSerialNumber + '"';

    endpoint = `${endpoint}?filter=${encodeURIComponent(filter1)}`;
    endpoint = `${endpoint}&filter=${encodeURIComponent(filter2)}`;

    if (!!excludeId) {
      const filter3 = 'id||$ne||' + excludeId;
      endpoint = `${endpoint}&filter=${encodeURIComponent(filter3)}`;
    }

    return this.httpClient.get<ManyResponse<RogueCase>>(endpoint);
  }

  getCase(caseId: number) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addQuery('filter', 'id||$eq||' + caseId)
      .get;

    return this.httpClient.get<ManyResponse<RogueCase>>(endpoint).pipe(
      map(response => response.data)
    );
  }

  getCaseUpdates(caseId: number) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-updates')
      .addQuery('filter', 'caseId||$eq||' + caseId)
      .get;

    return this.httpClient.get<ManyResponse<RogueCaseUpdates>>(endpoint).pipe(
      map(response => response.data)
    );
  }

  getCaseActionLog(caseId: number) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-action-log')
      .addQuery('filter', 'caseId||$eq||' + caseId)
      .get;

    return this.httpClient.get<ManyResponse<RogueCaseActionLog>>(endpoint).pipe(
      map(response => response.data)
    );
  }

  // public queryCases(pageSize: number = 15,
  //                   currentPage: number = 0,
  //                   sortDirection?: SortDirection,
  //                   sortBy?: string,
  //                   filter?: string | string[],
  //                   orFilter?: string | string[]): Observable<ManyResponse<RogueCase>> {

  //   let finalURL;
  //   const endpoint = Burly(this.config.rootUrl)
  //     .addSegment('/case-mgmt')
  //     .addQuery('page', (currentPage + 1))
  //     .addQuery('limit', pageSize);

  //   if (sortDirection && sortBy) {
  //     endpoint.addQuery('sort', `${sortBy},${sortDirection.toUpperCase()}`);
  //   }

  //   finalURL = endpoint.get;

  //   if (filter) {
  //     if (filter instanceof Array) {
  //       if (filter.length > 0) {
  //         filter.forEach((filterValue, index) => {
  //           if (index === 0) {
  //             finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
  //           } else {
  //             finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
  //           }
  //         });
  //       }
  //     } else {
  //       finalURL = `${finalURL}&filters=${encodeURIComponent(filter)}`;
  //     }
  //   }

  //   if (orFilter) {
  //     if (orFilter instanceof Array) {
  //       if (orFilter.length > 0) {
  //         orFilter.forEach((filterValue, index) => {
  //           if (index == 0) {
  //             finalURL = `${finalURL}&or=${encodeURIComponent(filterValue)}`;
  //           } else {
  //             finalURL = `${finalURL}&or=${encodeURIComponent(filterValue)}`;
  //           }
  //         });
  //       }
  //     } else {
  //       finalURL = `${finalURL}&or=${encodeURIComponent(orFilter)}`;
  //     }
  //   }

  //   return this.httpClient.get<ManyResponse<RogueCase>>(finalURL);
  // }

  public queryCases(pageSize: number = 15,
                    currentPage: number = 0,
                    sortDirection: 'ASC' | 'DESC' | '' = 'DESC',
                    sortBy: string = 'id',
                    filters: SCondition | null): Observable<ManyResponse<RogueCase>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection && sortDirection != null) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }

    if (!!filters) {
      qb.search(filters);
    }

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .appendRawQueryString(qb.query(false));

    finalURL = endpoint.get;

    return this.httpClient.get<ManyResponse<RogueCase>>(finalURL);
  }

  public exportToExcel(cases: RogueCase[]) {
    return new Observable(subscriber => {
      let endpoint = Burly(this.config.rootUrl)
        .addSegment('/case-mgmt')
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {
        logExport: cases
      };
      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });
  }

  public queryCaseMeeting(pageSize: number = 999,
                          currentPage: number = 0,
                          sortDirection: 'ASC' | 'DESC' | '' = 'ASC',
                          sortBy: string = 'ID',
                          filters: SCondition | null): Observable<ManyResponse<RogueCaseMeeting>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection && sortDirection != null) {
      qb.sortBy({ field: sortBy, order: sortDirection });
    }

    // if (!!filters) {
    //   qb.search(filters);
    // }

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-meeting')
      .appendRawQueryString(qb.query(false));

    finalURL = endpoint.get;

    return this.httpClient.get<ManyResponse<RogueCaseMeeting>>(finalURL);
  }

  public queryCaseOpenMeetings(pageSize: number = 999,
                               currentPage: number = 0,
                               sortDirection: 'ASC' | 'DESC' | '' = 'ASC',
                               sortBy: string = 'ID',
                               filters: SCondition | null): Observable<ManyResponse<RogueCaseMeeting>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection && sortDirection != null) {
      qb.sortBy({ field: sortBy, order: sortDirection });
    }

    // if (!!filters) {
    //   qb.search(filters);
    // }

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-meeting-open')
      .appendRawQueryString(qb.query(false));

    finalURL = endpoint.get;

    return this.httpClient.get<ManyResponse<RogueCaseMeeting>>(finalURL);
  }

  public exportMeetingToExcel(meeting: RogueCaseMeeting[]) {
    return new Observable(subscriber => {
      let endpoint = Burly(this.config.rootUrl)
        .addSegment('/case-meeting')
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType; } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {
        meetingExport: meeting
      };
      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });
  }

  public exportOpenMeetingToExcel(meeting: RogueCaseMeeting[]) {
    return new Observable(subscriber => {
      let endpoint = Burly(this.config.rootUrl)
        .addSegment('/case-meeting-open')
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType; } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {
        meetingExport: meeting
      };
      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });
  }

  public getCaseTypes(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/caseTypes')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ case_type_display: string }]>(endpoint).pipe(
      map(response => response.map(v => v.case_type_display))
    );
  }

  public getAssignedTo(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/assignedTo')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ case_assigned_to_display: string }]>(endpoint).pipe(
      map(response => response.map(v => v.case_assigned_to_display))
    );
  }

  public getPendingUser(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/pendingUser')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ currently_pending_user: string }]>(endpoint).pipe(
      map(response => response.map(v => v.currently_pending_user))
    );
  }

  public getPendingAction(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/pendingAction')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ currently_pending_action: string }]>(endpoint).pipe(
      map(response => response.map(v => v.currently_pending_action))
    );
  }

  public getPendingStatus(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/pendingStatus')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ currently_pending_status: string }]>(endpoint).pipe(
      map(response => response.map(v => v.currently_pending_status))
    );
  }

  public getTeamDecisions(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/teamDecision')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ post_meeting_recommendation: string }]>(endpoint).pipe(
      map(response => response.map(v => v.post_meeting_recommendation))
    );
  }

  public getFollowUpAnalysis(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/followUpAnalysis')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ tracker_action: string }]>(endpoint).pipe(
      map(response => response.map(v => v.tracker_action))
    );
  }

  public addCaseUpdate(update: RogueCaseUpdates){
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/case-updates')
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.post(endpointURL, update)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });
  }

  public deleteCaseUpdate(update: RogueCaseUpdates){
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/case-updates')
      .addSegment('/' + update.id)
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.delete(endpointURL)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });
  }

  public addCaseAction(action: RogueCaseActionLog){
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/case-action-log')
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.post(endpointURL, action)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });
  }

  public deleteCaseAction(action: RogueCaseActionLog){
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/case-action-log')
      .addSegment('/' + action.id)
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.delete(endpointURL)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });
  }

  public getActiveRogueMembers() {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/rogue-team')
      .addQuery('filter', 'activeMember||$eq||true')
      .get;

    return this.httpClient.get<ManyResponse<RogueTeam>>(endpoint).pipe(
      map(response => response.data)
    );
  }

  public updateRogueCase(rogue: RogueCase) {
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/case-mgmt')
    .addSegment('/' + rogue.id)
    .get;


    return this.httpClient.patch<RogueCase>(endpointURL, rogue);
  }

  public addRogueCase(rogue: RogueCase) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .get;

    return this.httpClient.post<RogueCase>(endpointURL, rogue);
  }

  public getRogueRecommendationTypes() {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/rogue-recommendations')
      .get;

    return this.httpClient.get<ManyResponse<RogueRecommendationTypes>>(endpoint).pipe(
      map(response => response.data)
    );
  }

  public getRogueTrackerActions() {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/rogue-tracker-actions')
      .get;

    return this.httpClient.get<ManyResponse<RogueTrackerActions>>(endpoint).pipe(
      map(response => response.data)
    );
  }

  public caseIsnAlreadyExist(masterPartIsn: number): Observable<number> {
    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/case-mgmt')
      .addSegment('/isn')
      .addSegment('/' + masterPartIsn)
      .addSegment('/exists');

    finalURL = endpoint.get;

    return this.httpClient.get<number>(finalURL).pipe(
      map(response => response)
    );
  }
}
